<template>
  <div v-if="isSupportChannelActive && initiated">
    <AIBotSupportChannel
      v-if="
        aiBotSupport &&
        (!channel.status ||
          ['ai_bot', 'ai_bot_completed'].indexOf(channel.status) >= 0)
      "
      :ongoing-chat="Boolean(channel.status)"
      :channel="channel"
      :history-messages="defaultMessages"
      :missed-chat="missedChat"
      @start-new-conversation="handleStartNewConversation"
    />
    <HumanSupportChannel
      v-if="
        (humanChatSupport && !aiBotSupport) ||
        (channel.status &&
          ['ai_bot', 'ai_bot_completed'].indexOf(channel.status) === -1)
      "
      ref="humanSupportChannelRef"
      :guest-user-channel="channel"
      :socket-path="socketPath"
    />
  </div>
</template>

<script>
import Reverse from 'lodash/reverse'
import Bus from '@utils/emitter'
import { authComputed } from '@state/modules/auth'
import AIBotSupportChannel from './ai-bot/ai-bot-support-channel'
import HumanSupportChannel from './human-support-channel.vue'
import { isLoggedIn } from '@/src/utils/auth'

import {
  getRequesterChatSessionApi,
  createRequesterChatSessionApi,
  clearOldAndCreateNewChatSessionApi,
  guestUserChatWithTechnicianCreateNewChatSessionApi,
} from './chat-api'

export default {
  name: 'SupportChannel',
  components: { AIBotSupportChannel, HumanSupportChannel },
  inject: { chatConfigContext: { config: {} } },
  props: {
    chatBoxWidth: { type: Number, default: 305 },
    socketPath: { type: String, required: true },
  },
  data() {
    return {
      isSupportChannelActive: false,
      initiated: false,
      channel: {},
      defaultMessages: [],
      missedChat: false,
    }
  },
  computed: {
    ...authComputed,
    aiBotSupport() {
      return this.chatConfigContext.config.botSupport
    },
    humanChatSupport() {
      return this.chatConfigContext.config.enabled
    },
  },
  watch: {
    'chatConfigContext.config': {
      handler: 'buildContainer',
      immediate: true,
    },
  },
  created() {
    const chatHandler = (payload) => {
      this.handleTransferToTechnician().then(() => {
        this.$refs.humanSupportChannelRef.handleShowBox()
      })
    }
    Bus.$on('app:transfer-chat', chatHandler)
    this.$once('hook:beforeDestroy', () => {
      Bus.$off('app:transfer-chat', chatHandler)
    })
    const missedChatHandler = () => {
      this.buildContainer()
      this.missedChat = true
    }
    Bus.$on('app:missed-chat', missedChatHandler)
    this.$once('hook:beforeDestroy', () => {
      Bus.$off('app:missed-chat', missedChatHandler)
    })
  },
  methods: {
    buildContainer() {
      const chatConfig = this.chatConfigContext.config
      if (chatConfig.enabled) {
        this.isSupportChannelActive = true
        this.$nextTick(() => {
          this.initiated = true
          this.getCurrentChannel()
        })
      } else {
        this.isSupportChannelActive = false
      }
    },
    getCurrentChannel() {
      if (isLoggedIn()) {
        return getRequesterChatSessionApi()
          .then((data) => {
            this.channel = data
            return data
          })
          .catch(() => {
            createRequesterChatSessionApi().then((data) => {
              this.channel = data.channel
              this.defaultMessages = Reverse(data.history || [])
            })
          })
      } else {
        clearOldAndCreateNewChatSessionApi().then((data) => {
          this.channel = data.channel
          this.defaultMessages = Reverse(data.history || [])
        })
      }
    },
    handleTransferToTechnician() {
      if (isLoggedIn()) {
        return this.getCurrentChannel()
      } else {
        return this.guestUserChatWithTechnician()
      }
    },
    guestUserChatWithTechnician() {
      return guestUserChatWithTechnicianCreateNewChatSessionApi(
        this.channel.id
      ).then((data) => {
        this.channel = data
        this.defaultMessages = Reverse(data.history || [])
        return data
      })
    },
    handleStartNewConversation(data) {
      this.channel = data.channel
      this.defaultMessages = Reverse(data.history || [])
    },
  },
}
</script>
